import React from 'react';
import './Pagination.css';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi'; // Modern thin icons

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className="premium-pagination-container">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        className="pag-nav-arrow"
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <HiOutlineChevronLeft />
      </button>

      <div className="pag-numbers-wrapper">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`pag-digit ${currentPage === page ? 'is-active' : ''}`}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        className="pag-nav-arrow"
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <HiOutlineChevronRight />
      </button>
    </nav>
  );
};

export default Pagination;